import { createContext, useState, useEffect } from "react";
import {
  onAuthStateChangedListener,
  signOutUser,
    createUserDocumentFromAuth,
} from "../utils/firebase/firebase.utils";
//as actual value i want to access
export const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => null,
});

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const value = { currentUser, setCurrentUser };
  useEffect(() => {
    const unsubsribe = onAuthStateChangedListener((user) => {
       if(user){
          createUserDocumentFromAuth(user);
       }
      setCurrentUser(user);
    });
    return unsubsribe;
  }, []);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
